<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-10-19 14:24:30
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-11-06 22:07:30
 * @FilePath: \seller.sviptrader.com\src\components\business\applySampleDrawer\closeTip\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog title="提示" :visible.sync="visible" :append-to-body="true" width="400px">
		<div class="flex-row-align-center">
			<img src="@/assets/public/warning-org.png" class="warn-img" alt="" />
			<p class="font-h4-medium ml-6 yx-color-text-primary">是否确认取消操作？</p>
		</div>
		<div class="yx-color-text-primary font-h4-regular mt-8 ml-24">取消将不保存您当前的操作。</div>
		<div class="footer-dialog" slot="footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="confirm">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
		};
	},
	methods: {
		show() {
			this.visible = true;
		},
		confirm() {
			this.visible = false;
			this.$emit('colse');
		},
	},
};
</script>
<style lang="less" scoped>
.warn-img {
	width: 16px;
	height: 16px;
}
</style>
